const STEPS = [50, 100, 250, 500, 1000, 2500, 5000, 10000, 25000, 50000]

const PROVIDERS = {
  gmail: 1,
  outlook: 1.15,
  yahoo: 1.4
}

const VERDICTS = {
  50: "Quiet first day. Almost all of this lands in the inbox.",
  100: "Still a polite knock. Providers have barely noticed the new IP.",
  250: "A few deferrals start to show. Yahoo is already a little suspicious.",
  500: "The IP is talking louder than a new neighbor should.",
  1000: "Gmail is watching. Outlook is slowing you down. Yahoo is already sorting some of this to spam.",
  2500: "This looks like a burst, not a warm-up. Deferrals pile up.",
  5000: "Providers are pushing back. A lot of this waits, then slips to spam.",
  10000: "You skipped the ramp. Inbox share is the exception, not the rule.",
  25000: "The new IP looks like a spray. Most mail never reaches the inbox.",
  50000: "Gmail has seen enough. Most of this lands in spam and the IP starts its reputation in a hole."
}

function formatVolume(value) {
  if (value >= 1000) {
    const thousands = value / 1000
    return Number.isInteger(thousands) ? `${thousands}k` : `${thousands}k`
  }
  return String(value)
}

function mix(volume, strictness) {
  const v = volume * strictness
  if (v <= 100) return {inbox: 96, deferred: 3, spam: 1}
  if (v <= 250) return {inbox: 88, deferred: 8, spam: 4}
  if (v <= 500) return {inbox: 72, deferred: 18, spam: 10}
  if (v <= 1000) return {inbox: 55, deferred: 25, spam: 20}
  if (v <= 2500) return {inbox: 38, deferred: 26, spam: 36}
  if (v <= 5000) return {inbox: 24, deferred: 26, spam: 50}
  if (v <= 10000) return {inbox: 14, deferred: 22, spam: 64}
  if (v <= 25000) return {inbox: 8, deferred: 16, spam: 76}
  return {inbox: 4, deferred: 10, spam: 86}
}

function paintBar(row, shares) {
  const inbox = shares.inbox / 100
  const deferred = (shares.inbox + shares.deferred) / 100
  row.querySelector("[data-share=inbox]").style.transform = `scaleX(${inbox})`
  row.querySelector("[data-share=deferred]").style.transform = `scaleX(${deferred})`
  row.querySelector("[data-share=spam]").style.transform = "scaleX(1)"
}

function render(root) {
  const slider = root.querySelector("[data-learn-volume]")
  const index = Number(slider?.value || 0)
  const volume = STEPS[index] || STEPS[0]
  const label = root.querySelector("[data-learn-volume-label]")
  if (label) label.textContent = formatVolume(volume)
  if (slider) slider.setAttribute("aria-valuetext", `${volume} messages on day 1`)
  Object.keys(PROVIDERS).forEach((key) => {
    const row = root.querySelector(`[data-learn-provider='${key}']`)
    if (row) paintBar(row, mix(volume, PROVIDERS[key]))
  })
  const verdict = root.querySelector("[data-learn-verdict]")
  if (verdict) verdict.textContent = VERDICTS[volume] || VERDICTS[50]
}

export function mount(root) {
  root.querySelector("[data-learn-volume]")?.addEventListener("input", () => render(root))
  render(root)
}
